const initial = [
  {
    action: 'access',
    subject: 'accessDenied'
  },

  {
    action: 'access',
    subject: 'initialAccess'
  },

  {
    action: 'access',
    subject: 'initialSetup'
  },

  {
    action: 'read',
    subject: 'readAcademias'
  },

  {
    action: 'read',
    subject: 'readUsuario'
  }
]

export default initial
